module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "close": _vm.close
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('reward.new')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddNext),
      expression: "showAddNext"
    }],
    class: 'btn btn-tile uppercase ' + _vm.buttonColor,
    staticStyle: {
      "max-height": "200px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNext
    }
  }, [_vm._v(_vm._s(_vm.$t('reward.addNext')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAddNext),
      expression: "!showAddNext"
    }]
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'title'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('title')
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'price'
    }
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "reward-price"
    }
  }, [_vm._v(_vm._s(_vm.$t("reward.price")))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.$t("reward.price")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price),
      expression: "form.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])], 1), _vm._v(" "), _c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'quantity'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.quantity),
      expression: "form.quantity",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('reward.quantity')
    },
    domProps: {
      "value": (_vm.form.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "quantity", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'description'
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "type": "text",
      "placeholder": _vm.$t('reward.description')
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.form.photo.url) ? _c('div', [_c('img', {
    staticClass: "reward-image",
    attrs: {
      "src": _vm.$server_url + _vm.form.photo.url,
      "alt": ""
    }
  })]) : _c('div', [_c('img', {
    staticClass: "reward-image",
    attrs: {
      "src": _vm.form.photo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('form-error', {
    attrs: {
      "errors": _vm.errors,
      "attribute": 'photo'
    }
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg button-wide-crowd mb-0 uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.addDocuments.$refs.input.click()
      }
    }
  }, [(!_vm.form.photo.url && !_vm.image) ? _c('span', [_vm._v(_vm._s(_vm.$t("profile.edit.addImageButton")))]) : _c('span', [_vm._v(_vm._s(_vm.$t("profile.edit.changeImageButton")))])]), _vm._v(" "), _c('upload-base64', {
    ref: "addDocuments",
    attrs: {
      "multiple": false,
      "done": _vm.getFile
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddNext),
      expression: "showAddNext"
    }],
    staticClass: "mt-20",
    staticStyle: {
      "height": "40px"
    }
  }, [_c('alert', {
    attrs: {
      "success": _vm.alert.success
    }
  })], 1), _vm._v(" "), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAddNext),
      expression: "!showAddNext"
    }],
    attrs: {
      "success": _vm.alert.success
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAddNext),
      expression: "!showAddNext"
    }],
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("save")))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6def4e7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reward/Form.vue
// module id = 815
// module chunks = 1